module.exports = __webpack_public_path__ + "img/gradeFunnel2.2d760a21.jpg";